import { NgModule } from '@angular/core';
import { GlobalFilterWithDateDirective } from './global-filter-with-date.directive';

const DIRECTIVES = [
  GlobalFilterWithDateDirective
];

@NgModule({
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class DirectiveModule {}
